<template>
  <div>
    <header>
      <div class="container">
        <div class="d-flex align-items-center logo">
          <img alt="logo" src="../assets/logo.png" class="img-fluid me-3">
          110年度 勞動及職業安全衛生研究所
          <br class="d-md-none">
          研究成果線上展
        </div>
      </div>
    </header>
    <section>
      <div class="banner">
        <img src="../assets/banner.png" alt="banner" class="img-fluid" usemap="#Map">
        <map name="Map" id="Map" v-if="!is_mobile">
          <area href="#" v-b-modal.exhibitionModal-3 coords="200,570,410,680" shape="rect">
          <area href="#" v-b-modal.exhibitionModal-1 coords="305,680,520,815" shape="rect">
          <area href="#" v-b-modal.exhibitionModal-4 coords="465,550,665,680" shape="rect">
          <area href="#" v-b-modal.exhibitionModal-5 coords="1290,550,1490,675" shape="rect">
          <area href="#" v-b-modal.exhibitionModal-2 coords="1440,680,1655,815" shape="rect">
          <area href="#" v-b-modal.exhibitionModal-6 coords="1545,570,1750,675" shape="rect">
          <area href="#" v-b-modal.videoModal coords="795,395,1175,595" shape="rect">
        </map>
        <b-modal size="xl" hide-header hide-footer id="videoModal">
          <div class="title d-flex justify-content-end align-items-center">
            <b-button variant="default" data-dismiss="videoModal" @click="$bvModal.hide('videoModal')">
              <img src="../assets/icon_close.png" alt="icon_close">
            </b-button>
          </div>
          <div class="d-flex justify-content-center mb-3">
            <div class="ratio ratio-16x9">
              <video controls>
                <source src="../assets/video.mp4" type="video/mp4">
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
          <div class="content">
            在勞動部積極推動「安穩工作」、「安心職場」、「安全勞動」的勞動三安政策之下，勞動部勞動及職業安全衛生研究所持續進行各項研究計畫，今年透過線上展覽方式於2021年11月15日-2022年1月23日展示研究成果，向社會大眾介紹最新的勞動市場和勞動關係趨勢，以及職業安全衛生最新知識及防災技術！
          </div>
        </b-modal>
        <b-modal dialog-class="exhibition-modal" body-class="p-0" size="xl" hide-header hide-footer :id="'exhibitionModal-' + exhibition.id" v-for="exhibition in exhibitions" :key="exhibition.id">
          <div class="exhibition-wrapper">
            <div :id="'exhibition-' + exhibition.id" class="exhibition-item">
              <div class="row">
                <div class="col-md-4">
                  <div class="exhibition-img">
                    <img :src="require('../assets/exhibition' + exhibition.id + '.png')" alt="exhibition-title" class="img-fluid">
                  </div>
                </div>
                <div class="col-md-8">
                  <div class="title d-flex justify-content-between align-items-center">
                    <h3>展區介紹</h3>
                    <b-button variant="default" :data-dismiss="'exhibitionModal-' + exhibition.id" @click="$bvModal.hide('exhibitionModal-' + exhibition.id)">
                      <img src="../assets/icon_close.png" alt="icon_close">
                    </b-button>
                  </div>
                  <div class="content">
                    <div class="row">
                      <div class="col-md-4" v-for="value in exhibition.value" :key="value.title">
                        <a :href="value.link" :class="'exhibition-link color-' + exhibition.id" target="_blank">
                          {{ value.title }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
    </section>
    <section class="video" v-if="is_mobile">
      <div class="container">
        <div class="row">
          <div class="col-md-5">
            <div class="ratio ratio-16x9">
              <video controls>
                <source src="../assets/video.mp4" type="video/mp4">
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
          <div class="col-md-7">
            <div class="content">
              在勞動部積極推動「安穩工作」、「安心職場」、「安全勞動」的勞動三安政策之下，勞動部勞動及職業安全衛生研究所持續進行各項研究計畫，今年透過線上展覽方式於2021年11月15日-2022年1月23日展示研究成果，向社會大眾介紹最新的勞動市場和勞動關係趨勢，以及職業安全衛生最新知識及防災技術！
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="exhibition" v-if="is_mobile">
      <div class="container">
        <h2 class="d-flex justify-content-center align-items-center">展區介紹</h2>
        <nav>
          <ul class="nav nav-pills d-flex justify-content-center align-items-center">
            <li :class="select_exhibition === null ? 'active' : ''" v-if="!is_mobile" @click="select(null)">全部</li>
            <li :class="select_exhibition === exhibition.id ? 'active' : ''" v-for="exhibition in exhibitions" :key="exhibition.id" @click="select(exhibition.id)">{{ exhibition.title }}</li>
          </ul>
        </nav>
        <div class="exhibition-wrapper">
          <div :id="'exhibition-' + exhibition.id" class="exhibition-item" v-for="exhibition in exhibitions" :key="exhibition.id" v-show="select_exhibition === null || select_exhibition ===exhibition.id">
            <div class="row">
              <div class="col-md-4">
                <div class="exhibition-img">
                  <img :src="require('../assets/exhibition-' + exhibition.id + '.png')" alt="exhibition-title" class="img-fluid">
                  <div class="exhibition-title">
                    {{ exhibition.title }}
                  </div>
                </div>
              </div>
              <div class="col-md-8">
                <div class="row">
                  <div class="col-md-4" v-for="value in exhibition.value" :key="value.title">
                    <a :href="value.link" :class="'exhibition-link color-' + exhibition.id" target="_blank">
                      {{ value.title }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer>
      <div class="container">
        <div class="d-flex justify-content-between align-items-center flex-md-row flex-column">
          <div class="logo">
            <img src="../assets/footer-logo.png" alt="footer-logo" class="img-fluid">
          </div>
          <div class="info">
            勞動部勞動及職業安全衛生研究所版權所有
            <br>
            本所服務專線：(02)2660-7600
            <br class="d-md-none">
            傳真號碼：(02)2660-7732
            <br class="d-md-none">
            本所地址：22143新北市汐止區橫科路407巷99號
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script src="https://cdnjs.cloudflare.com/ajax/libs/jQuery-rwdImageMaps/1.6/jquery.rwdImageMaps.min.js" integrity="sha512-eZB7hQa0bRlrKMQ2njpP0d/Klu6o30Gsr8e5FUCjUT3fSlnVkm/1J14n58BuwgaMuObrGb7SvUfQuF8qFsPU4g==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>
<script>
import json from '../json/data.json'

export default {
  name: 'Home',
  data() {
    return {
      select_exhibition: window.innerWidth >= 768 ? null : 1,
      exhibitions: json
    }
  },
  methods: {
    select(id) {
      this.select_exhibition = id;
    }
  },
  computed: {
    is_mobile: function () {
      return window.innerWidth < 768
    },
  },
}

window.$('img[usemap]').rwdImageMaps();
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../node_modules/bootstrap/scss/bootstrap.scss";

header {
  background: linear-gradient(90deg, #245AA2 0%, #3BB9A3 100%);

  .logo {
    height: 60px;
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    color: #FFFFFF;

    @include media-breakpoint-down(md) {
      line-height: 160%;
    }
  }
}

.video {
  background: #F2F2F2;
  mix-blend-mode: darken;
  padding: 60px 0;

  @include media-breakpoint-down(md) {
    padding: 20px 0;
  }

  .content {
    height: 100%;
    display: flex;
    align-items: center;
    padding-left: 100px;

    @include media-breakpoint-down(md) {
      padding-left: 0;
      padding-top: 20px;
    }
  }
}

.exhibition {
  padding: 100px 0;

  @include media-breakpoint-down(md) {
    padding: 30px 0;
  }

  nav {
    margin: 60px 0;

    @include media-breakpoint-down(md) {
      margin: 30px 0;
    }

    li {
      padding: 0 15px;
      cursor: pointer;
      margin-bottom: 10px;

      @include media-breakpoint-down(md) {
        padding: 0 10px;
      }

      &.active {
        font-weight: bold;
      }

      & + li {
        border-left: 1px solid #444444;
      }
    }
  }
}

.exhibition-modal {
  &.modal-dialog {
    @include media-breakpoint-down(lg) {
      max-width: calc(100vw - 20px);
    }
  }

  .title {
    margin-bottom: 30px;

    h3 {
      font-weight: bold;
      font-size: 24px;
      line-height: 28px;
      color: #444444;
      margin-top: 50px;
    }
  }

  .content {
    padding-right: 50px;

    @include media-breakpoint-down(lg) {
      padding-right: 20px;
    }
  }
}

.exhibition-wrapper {
  .exhibition-item {

    @include media-breakpoint-down(md) {
      margin-top: 50px;
    }

    .exhibition-img {
      position: relative;

      @include media-breakpoint-down(md) {
        margin-bottom: 10px;
      }

      .exhibition-title {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        font-size: 24px;
        line-height: 28px;
        text-align: center;
        color: #444444;
      }
    }

    .exhibition-link {
      height: 120px;
      padding: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #FFFFFF;
      border: 1px solid #49A0D3;
      font-size: 16px;
      line-height: 160%;
      color: #444444;
      text-decoration: none;
      margin-bottom: 20px;

      @include media-breakpoint-down(lg) {
        padding: 10px;
      }

      @include media-breakpoint-down(md) {
        height: 100px;
        margin-bottom: 10px;
      }

      &.color-1 {
        border: 1px solid #49A0D3;
      }

      &.color-2 {
        border: 1px solid #65B533;
      }

      &.color-3 {
        border: 1px solid #D7B348;
      }

      &.color-4 {
        border: 1px solid #35C6BD;
      }

      &.color-5 {
        border: 1px solid #E3716A;
      }

      &.color-6 {
        border: 1px solid #C19E64;
      }
    }
  }
}

footer {
  padding: 10px 0;
  background: linear-gradient(90deg, #245AA2 0%, #3BB9A3 100%);

  @include media-breakpoint-down(md) {
    padding: 20px 0;
  }

  .info {
    font-size: 14px;
    line-height: 160%;
    text-align: right;
    color: #FFFFFF;
  }
}
</style>
